import { useEffect, useState } from 'react';

import classNames from 'classnames';

import fieldErrorParser from 'utils/fieldErrorParser';

import LabelWithErrors from '../LabelWithErrors/LabelWithErrors';
import style from './ToggleInput.module.css';

interface Props {
  label: string;
  checked: boolean;
  value: any;
  size?: 'small' | 'medium' | 'large';
  onChange: (val: any) => void;
}
const ToggleInput = ({ label, checked, onChange, value, size }: Props) => {
  const [isChecked, setIsChecked] = useState<boolean>(checked);
  useEffect(() => {
    onChange(isChecked ? value : null);
  }, [isChecked]);
  return (
    <div onClick={() => setIsChecked(val => !val)} className={style.toggleContaner}>
      <label className={style.label}>{label}</label>
      <label className={`${style.toggleSwitch} ${style[size ?? 'medium']}`}>
        <input type="checkbox" checked={isChecked} onChange={() => setIsChecked(val => !val)} />
        <span className={style.slider}></span>
      </label>
    </div>
  );
};

export default ToggleInput;
